module.exports = __webpack_public_path__ + "static/media/title-bg.14098f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dialog/title-bg.png
// module id = 406
// module chunks = 1